import { getFeatureFlag } from './feature-flags-storage';

export const isMasonryContentEnabled = () => getFeatureFlag('masonryContent');
